import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, TitleStrategy, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { CustomTitleStrategy } from '@core/providers/custom-title-strategy';
import { provideGlobalInjectorInitializer } from '@core/providers/global-injector';
import { provideHttpInterceptors } from '@core/providers/http-interceptor';
import { provideAnalytics } from '@core/providers/matomo';
import { provideRouteMeta } from '@core/providers/route-meta';
import { provideSentry } from '@core/providers/sentry';
import { provideStorage } from '@core/providers/storage';
import { provideTranslation } from '@core/providers/translation';
import { environment } from '@environments/environment';
import { provideFlipper, withBrowserContext, withNavigationListener } from '@flipper';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { APP_ROUTES } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnalytics(),
    provideSentry(),
    provideTranslation(),
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    ),
    provideRouteMeta(),
    provideGlobalInjectorInitializer(),
    provideHttpInterceptors(),
    provideStorage(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          gfm: true,
          breaks: false,
          pedantic: false
        }
      }
    }),
    provideFlipper(
      {
        appId: '49340000-3c7e-a2af-2c5e-08dcc5c257fb',
        apiUrl: environment.wordpressUrl,
        basePath: 'feature-management',
        caching: {
          featureFlagCacheKey: 'fl',
          userContextCacheKey: 'uc',
          storageType: 'sessionstorage',
          ttl: 1000 * 10 // 5 seconds
        }
      },
      withBrowserContext(),
      withNavigationListener()
    ),
    {
      provide: TitleStrategy,
      useClass: CustomTitleStrategy
    }
  ]
};
